/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import { mode } from "../../../helpers/types";
import TruckloadIcon from "../../icons/TruckloadIcon";
import LessThanTruckloadIcon from "../../icons/LessThanTruckloadIcon";
import IntermodalIcon from "../../icons/IntermodalIcon";
import Modal from "../../Modal";
import messages from "../../../helpers/messages";

function SelectModesModal({
  open,
  modes,
  winningModes,
  handleClose,
  handleNextButton,
  setWinningModes
}) {
  const isModeSelected = type => {
    return winningModes.some(x => x.mode === type);
  };

  const handleModeSelection = type => {
    const hasMode = winningModes.some(x => x.mode === type);
    let updatedModes;
    if (hasMode) {
      updatedModes = winningModes.filter(x => x.mode !== type);
    } else {
      updatedModes = [...winningModes, modes.find(m => m.mode === type)];
    }

    setWinningModes(updatedModes);
  };

  const Mode = ({ type, text, className, children }) => (
    <button
      data-testid={text}
      className={`bg-white ${className ? className : ""} ${
        isModeSelected(type) ? "selected" : ""
      }`}
      onClick={() => handleModeSelection(type)}
    >
      {children}
      <span className="block zeta pt-8">{text}</span>
    </button>
  );

  return (
    <Modal
      title={messages.awardUpload.defaultMessage}
      open={open}
      large
      handleClose={handleClose}
      titleClass="modal__title_light uppercase"
      bodyClass="border-top-grey px-24 pt-24 award-upload"
      closeButtonClass="modal__close-button mr-16 mt-16"
      modalStyle={{ width: "540px" }}
    >
      <p
        data-testid="select-modes-modal"
        className="font-size-16 text-dim-grey mb-20"
      >
        {messages.pleaseSelectTheModesWithAwardsToUpload.defaultMessage}
      </p>
      <div className="mode-selected flex">
        {modes.some(x => x.mode === mode.tl) && (
          <Mode
            type={mode.tl}
            className="mr-20"
            text={messages.truckload.defaultMessage}
          >
            <TruckloadIcon width="55" height="22" />
          </Mode>
        )}
        {modes.some(x => x.mode === mode.ltl) && (
          <Mode
            type={mode.ltl}
            className="mr-20"
            text={messages.lessThanTruckload.defaultMessage}
          >
            <LessThanTruckloadIcon width="55" height="22" />
          </Mode>
        )}
        {modes.some(x => x.mode === mode.imdl) && (
          <Mode
            type={mode.imdl}
            className="mr-20"
            text={messages.intermodal.defaultMessage}
          >
            <IntermodalIcon width="55" height="22" />
          </Mode>
        )}
      </div>
      <div className="grid fr">
        <div className="grid__cell my-24">
          <button
            data-testid="next-button"
            className="primary-button one-whole cursor-pointer univers-67-bold-cond short-button"
            disabled={!winningModes.length}
            onClick={() => handleNextButton(winningModes)}
          >
            {messages.next.defaultMessage}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default SelectModesModal;
